'use strict';

import React from 'react';

import { connect } from 'react-redux';

import Logger from '../../../utils/Logger';
import classnames from 'classnames';
import { formatDate, formatTime } from '../../../utils/TimeUtils';
import OTButton from '../../tag/OTButton';
import { FormattedMessage } from 'react-intl';
import OTIcon from '../../tag/OTIcon';
import { getDepartmentDisplay } from '../../../utils/TimelineUtils';
import BaseQuestionnaireListItem from '../BaseQuestionnaireListItem';
import { showOmavointiQuestionnaireModal } from '../../../data/questionnaires/actions';
import { QUESTIONNAIRES, SERVICES } from '../../../data/reducer';
import MobileClientModal from '../MobileClientModal';
import { LONG_DESCRIPTON_FORM_CODE } from '../../../definitions/QuestionnaireConstants';

const { id: module_id } = module;
const logger = Logger(module_id);

class QuestionnaireListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMobileClientModal: false,
    };
  }

  toggleModalState = () => {
    this.setState({ showMobileClientModal: !this.state.showMobileClientModal });
  };

  clicked = () => {
    let { data, showOmavointiQuestionnaireModal, mobileClientState } =
      this.props;

    !mobileClientState
      ? showOmavointiQuestionnaireModal(data.formCode, data.link)
      : this.toggleModalState();
  };

  /*
      If the questionnaire is 15d, show the description given in the data.
      Else show generic description
     */
  renderLongDescription() {
    let { formCode, longDescription } = this.props.data;
    return formCode === LONG_DESCRIPTON_FORM_CODE ? (
      longDescription && <div>{longDescription}</div>
    ) : (
      <div>
        <FormattedMessage id={`${module_id}.generic.info`} />
      </div>
    );
  }

  render() {
    let {
      name,
      answerDateTime,
      description,
      status,
      endDateTime,
      appointmentData,
      longDescription,
    } = this.props.data;
    let leftDate,
      rightDate = null;
    let completed = false;

    if (status !== 'COMPLETED' && endDateTime) {
      leftDate = <span>Täytä viimeistään {formatDate(endDateTime)}</span>;
    }

    if (status === 'COMPLETED') {
      completed = true;
      rightDate = <span>Vastattu {formatDate(answerDateTime)}</span>;
    }

    if (appointmentData) {
      name = (
        <FormattedMessage
          id={`${module_id}.questionnaire.with.appointment`}
          values={{
            name: name,
            department: getDepartmentDisplay(appointmentData.department),
            date: formatDate(appointmentData.date),
            time: formatTime(appointmentData.date),
          }}
        />
      );
    }

    return (
      <>
        <BaseQuestionnaireListItem
          left={
            <>
              <span className={'ot-queryitem__name'}>{name}</span>
              {this.renderLongDescription()}
              {description && (
                <>
                  <br />
                  <span
                    className={classnames('ot-queryitem__description', {
                      completed,
                    })}
                  >
                    <OTIcon
                      config={{
                        type: 'custom',
                        name: 'palaute',
                        color: 'darkblue',
                      }}
                      style={{
                        height: '13px',
                        width: '15px',
                        marginRight: '5px',
                      }}
                    />
                    {description}
                  </span>
                </>
              )}
            </>
          }
          leftWidth={'span6'}
          center={leftDate}
          right={
            <>
              {status === 'ACTIVE' || status === 'STARTED' ? (
                <OTButton
                  color={'light'}
                  className={'pull-right ot-queryitem__button'}
                  onClick={this.clicked}
                >
                  <FormattedMessage id={'navigate.to.answer'} />
                </OTButton>
              ) : (
                <span className={'pull-right ot-queryitem__answered'}>
                  <OTIcon
                    config={{ type: 'fa', name: 'icon-ok' }}
                    style={{ marginRight: '8px' }}
                  />
                  {rightDate}
                </span>
              )}
            </>
          }
          rightWidth={'span3'}
        />
        {this.state.showMobileClientModal && (
          <MobileClientModal
            isOpen={this.state.showMobileClientModal}
            hideModal={() => this.toggleModalState()}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    mobileClientState: state[QUESTIONNAIRES].mobileClientState,
  };
};

export default connect(mapStateToProps, { showOmavointiQuestionnaireModal })(
  QuestionnaireListItem
);
